export const clinicalTheme = {
  doughnutChartDanger: '#e20000',
  doughnutChartPrimary: '#409eb0',
  doughnutChartBackground: '#c7dde2',

  rangeSliderFilled: '#409eb0',

  voucherUsedStatus: '#ff8413',
  voucherExpiredStatus: '#e20000',

  dashboardSettingsButtonAppearance: 'filled',
  dashboardSettingsButtonStatus: 'info',

  chartTimeUsedColors: [
    '#c7dde2',
    '#409eb0'
  ],
};